import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { PickingLineItem } from './PickingLineItem';
import { PalletSummaryDto } from '../../../../types/picking';
import { PickingLine } from './types';

interface SortablePickingLineItemProps {
  line: PickingLine;
  index: number;
  isSelected: boolean;
  isActive: boolean;
  isPrevious: boolean;
  pallets: PalletSummaryDto[];
  editingLocation: number | null;
  editingQuantity: number | null;
  newLocation: string;
  newQuantity: string;
  showPalletInfo: string | null;
  onLineClick: (index: number) => void;
  onLocationEdit: (lineNo: number, location: string) => void;
  onQuantityEdit: (lineNo: number, quantity: number) => void;
  onStartLocationEdit: (lineNo: number, location: string) => void;
  onStartQuantityEdit: (lineNo: number, quantity: string) => void;
  onLocationChange: (value: string) => void;
  onQuantityChange: (value: string) => void;
  onSplitLine: (lineNo: number) => void;
  onPickLine: (lineNo: number, qty: number) => void;
  onUndoPicking: (lineNo: number) => void;
  onShowPalletInfo: (palletId: string | null) => void;
}

export const SortablePickingLineItem: React.FC<SortablePickingLineItemProps> = (props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: props.line.pListLineNo });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="relative flex items-center gap-3 pl-2"
    >
      {/* Drag Handle - 6 dots (2x3 grid) - Always visible, positioned inside frame */}
      <div
        {...attributes}
        {...listeners}
        className="flex-shrink-0 cursor-grab active:cursor-grabbing text-gray-400 hover:text-gray-600 touch-none"
        title="Dra for å flytte"
      >
        <div className="grid grid-cols-2 gap-1.5">
          <div className="w-2.5 h-2.5 bg-current rounded-full" />
          <div className="w-2.5 h-2.5 bg-current rounded-full" />
          <div className="w-2.5 h-2.5 bg-current rounded-full" />
          <div className="w-2.5 h-2.5 bg-current rounded-full" />
          <div className="w-2.5 h-2.5 bg-current rounded-full" />
          <div className="w-2.5 h-2.5 bg-current rounded-full" />
        </div>
      </div>

      {/* Original PickingLineItem - takes remaining width */}
      <div className="flex-1 min-w-0">
        <PickingLineItem {...props} />
      </div>
    </div>
  );
};
